import React from 'react';

// MUI
import { Chip } from '@mui/material';

// Utils
import { getBatchStatusTone } from '~/utils/batch-status';

// Styles
import './styles.scss';

/**
 * Small coloured pill for a status string. The colour follows the status wording (see getBatchStatusTone), or
 * pass `tone` to set it explicitly.
 */
const StatusChip = ({ status, tone, className = '' }) => {
  const resolvedTone = tone || getBatchStatusTone(status);

  return (
    <Chip
      size="small"
      label={status || ' -'}
      className={`olcStatusChip olcStatusChip--${resolvedTone} ${className}`.trim()}
    />
  );
};

export default StatusChip;
